import React, {useEffect, useState} from 'react';
import {Organisation} from "types/Organisation";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useNotifications} from "context/NotificationContext";

type Props = {
    organisation: Organisation | null
    show: boolean
    onDelete?: (organisation: Organisation) => any
    onDeleteFail?: (organisation: Organisation, error: unknown) => any
    onCancel?: () => any
}

function DeleteOrganisation(props: Props) {
    const {organisation, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(organisation?.name || 'this organisation');
    const {mutateAsync: deleteOrganisation} = useMutation(ngage.organisations.destroy)

    const {notify} = useNotifications()

    useEffect(() => {
        if(organisation) setName(organisation.name)
    }, [organisation]);

    async function handleDeleteOrganisation() {
        if (organisation) {
            try {
                await deleteOrganisation(organisation.id)
                await invalidate('organisations.all')

                notify("success", "Organisation Deleted", `${organisation.name} has been permanently removed`)
                if (onDelete) onDelete(organisation)
            } catch (error) {
                notify("error", "Organisation Not Deleted", `${organisation.name} could not be removed`)
                if (onDeleteFail) onDeleteFail(organisation, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete Organisation"
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteOrganisation}
            onCancel={handleCancel}
        />
    );
}

export default DeleteOrganisation;